import { partialRight } from 'lodash-es'
import { checkDateQueryMatch, getDateRange } from 'syft-acp-core/lib/dateFilter'

export const getDateRangeListing = partialRight(getDateRange, 'start_date_gte', 'start_date_lte')
export const checkDateQueryMatchListing = partialRight(checkDateQueryMatch, 'start_date_gte', 'start_date_lte')
